(function () {
  const STAR =
    '<svg class="yokaa-star yokaa-star--full yokaa-star--sm" viewBox="0 0 24 24" width="12" height="12"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  function hashSeed(str) {
    let h = 0;
    for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return h;
  }

  function pickReviews(all, productId, count) {
    if (!Array.isArray(all) || !all.length) return [];
    const seed = hashSeed(String(productId));
    const offset = seed % all.length;
    const picked = [];
    const used = new Set();

    for (let i = 0; i < all.length * 2 && picked.length < count; i += 1) {
      const review = all[(offset + i) % all.length];
      const key = `${review.name}|${review.text}`;
      if (used.has(key)) continue;
      used.add(key);
      picked.push(review);
    }

    return picked;
  }

  function renderCard(review) {
    const initial = (review.name || '?').charAt(0).toUpperCase();
    const stars = STAR.repeat(5);
    return `
      <article class="yokaa-cr-card">
        <div class="yokaa-cr-card__top">
          <div class="yokaa-cr-card__avatar" aria-hidden="true">${initial}</div>
          <div class="yokaa-cr-card__info">
            <span class="yokaa-cr-card__name">${review.name}</span>
            <span class="yokaa-cr-card__badge">Verified buyer</span>
          </div>
          <div class="yokaa-cr-card__stars" aria-hidden="true">${stars}</div>
        </div>
        <p class="yokaa-cr-card__text" dir="rtl" lang="ar">${review.text}</p>
      </article>`;
  }

  function initSection(section) {
    const productId = section.dataset.productId;
    const jsonEl = document.getElementById('yokaa-store-reviews');
    const listEl = section.querySelector('[data-yokaa-cr-list]');
    const track = section.querySelector('[data-yokaa-cr-track]');
    const prev = section.querySelector('[data-yokaa-cr-prev]');
    const next = section.querySelector('[data-yokaa-cr-next]');

    if (!listEl || !track) return;

    let all = [];
    try {
      all = JSON.parse(jsonEl?.textContent || '[]');
    } catch (e) {
      all = [];
    }

    if (all.length > 6) {
      const picked = pickReviews(all, productId, Math.min(14, all.length));
      listEl.innerHTML = picked.map(renderCard).join('');
    }

    const scrollStep = () => {
      const card = listEl.querySelector('.yokaa-cr-card');
      return card ? card.offsetWidth + 14 : 320;
    };

    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  function boot() {
    document.querySelectorAll('[data-yokaa-cr]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
